(function() {
    'use strict';

    angular.module('stats', [
            'ui.router',

            'stats.constants',
            'stats.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'statsPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, statsPermissionsConst) {

        $stateProvider
            .state('layout.stats', {
                abstract: true,
                url: '/stats',
                data: {
                    title: 'Statystyki',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.stats.overall', {
                url: '/overall',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/overall-stats/overall-stats.html',
                        controller: 'OverallStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.products', {
                url: '/products',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/products-stats/products-stats.html',
                        controller: 'ProductsStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.packages', {
                url: '/packages',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/packages-stats/packages-stats.html',
                        controller: 'PackagesStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.sales', {
                url: '/sales',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/sales-stats/sales-stats.html',
                        controller: 'SalesStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki sprzedaży',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.montage', {
                url: '/montage',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/montage-stats/montage-stats.html',
                        controller: 'MontageStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki montaży',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.production', {
                url: '/production',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/production-stats/production-stats.html',
                        controller: 'ProductionStatsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Statystyki kostek i wysyłki',
                    modelPermission: statsPermissionsConst.view
                }
            })
            .state('layout.stats.productionLogs', {
                url: '/production-logs',
                views: {
                    'main@layout': {
                        templateUrl: 'app/stats/views/production-logs/production-logs.html',
                        controller: 'ProductionLogsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Logi produkcyjne',
                    modelPermission: statsPermissionsConst.productionLogs
                }
            });
    }
})();
